import styled from 'styled-components';

import { media } from 'utils/detection';

export default styled.div`
  display: inline-block;
  position: relative;

  ${media.medium`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
  `}
`;
